/* eslint-disable react-hooks/exhaustive-deps */
import { CloseOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../../assets/Images/icons/icon-back';
import { ROUTER } from '../../../constants/router';
import RiskRegisterService from '../../../services/RiskRegister.service';
import UserService from '../../../services/UserService';
import HistoryDrawer from '../RiskRegisterHistory/HistoryDrawer';
import Activity from './Activity';
import RegisterInfo from './RegisterInfo';
import Tabs from './Tabs';
import Comment from '../../data-flow/components/Comment';

export default function RiskRegisterDetail() {
    const { t } = useTranslation();
    let navigate = useNavigate();
    let { riskId } = useParams();

    const location = useLocation();
    const mode = location?.state?.mode;
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const [visibleHistories, setVisibleHistories] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(true);

    const [selectRR, setSelectRR] = useState();
    const [riskInfo, setRiskInfo] = useState();
    const [riskInfoTabs, setRiskInfoTabs] = useState();

    const getDetailInfo = async () => {
        try {
            const { data } = await RiskRegisterService.getDetailInfo(riskId);
            if (data?.resultData) {
                setRiskInfo(data?.resultData[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getRiskListTab = async () => {
        const { data } = await RiskRegisterService.getRiskListTab(riskId);
        if (data?.resultData) {
            setRiskInfoTabs(data?.resultData);
        }
    };

    useEffect(() => {
        getDetailInfo();
        getRiskListTab();
    }, [riskId]);

    useEffect(() => {
        if (mode === undefined) {
            navigate(`${ROUTER.RISK_MANAGEMENT.RR}?tab=2`);
        }
    }, [mode]);

    return (
        <Fragment>
            <div className="title flex">
                <button
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        if (admin) {
                            navigate(`${ROUTER.RISK_MANAGEMENT.RA}?tab=1`);
                        } else {
                            navigate(`${ROUTER.RISK_MANAGEMENT.RR}?tab=1`);
                        }
                    }}
                >
                    <IconBack />
                </button>
                {t('Risk Register')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {admin ? t('Risk Assessment') : t('Risk Register')} /
                </span>
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Risk Register List')} /{' '}
                </span>
                <span>{t('RR.CreateRR')}</span>
            </div>
            <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1">
                    <RegisterInfo
                        riskInfo={riskInfo}
                        setVisibleHistories={setVisibleHistories}
                        setIsChangeStatus={setIsChangeStatus}
                        getDetailInfo={getDetailInfo}
                        selectRR={selectRR}
                        setSelectRR={setSelectRR}
                        riskInfoTabs={riskInfoTabs}
                    />
                    {riskInfo?.comment && (
                        <Comment comment={riskInfo?.comment} />
                    )}
                    {riskInfo?.reason && (
                        <div className="col-span-1 bg-[#FFECF0] h-max rounded-xl p-4 pt-4 pb-6 my-4">
                            <div
                                className="text-sm font-semibold pb-2 flex justify-between items-center"
                                style={{ borderBottom: '3px solid #FFCFD8' }}
                            >
                                <span className="text-[#F0536F]">
                                    {t('RR.ReasonForRevise')}
                                </span>
                            </div>
                            <p className="text-xs mt-4">{riskInfo?.reason}</p>
                        </div>
                    )}
                    <Activity
                        riskInfo={riskInfo}
                        getDetailInfo={getDetailInfo}
                        mode={mode}
                    />
                </div>
                <div className="col-span-2">
                    <Tabs riskInfoTabs={riskInfoTabs} riskInfo={riskInfo} />
                </div>
            </div>
            <Drawer
                width={460}
                title={
                    <div className="flex justify-between items-center">
                        <span className="text-purple text-[17px]">
                            {t('History')}
                        </span>
                        <button
                            onClick={(e) => setVisibleHistories(false)}
                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                        >
                            <CloseOutlined />
                        </button>
                    </div>
                }
                placement="right"
                onClose={() => setVisibleHistories(false)}
                closable={false}
                open={visibleHistories}
                className="history"
            >
                <HistoryDrawer
                    isChangeStatus={isChangeStatus}
                    setIsChangeStatus={setIsChangeStatus}
                />
            </Drawer>
        </Fragment>
    );
}
